export enum Role {
  Sudo = "Sudo",
  User = "User",
  Admin = "Admin",
  Seller = "Seller",
  Broker = "Broker",
  Guest = "Guest",
}
